import {connect} from 'react-redux';
import React, {Component} from 'react';

import Map from '../Base/Map';

class Location extends Component {
    render() {
        const i18n = this.props.languages.i18n;
        return (
            <div id="location" className="geo">
                <h2>{i18n['objectPage.location']}</h2>
                {this.props.isGoogleApiInit &&
                this.props.objectPage.currentObject.id !== undefined &&
                this.props.defaultLat !== undefined &&
                <Map
                    id="map"
                    className="map"
                    lat={this.props.objectPage.currentObject.location.latitude}
                    lng={this.props.objectPage.currentObject.location.longitude}

                    centerLat={this.props.objectPage.currentObject.location.latitude}
                    centerLng={this.props.objectPage.currentObject.location.longitude}
                    circle={true}
                    zoom={15}
                />}
                <div className="geo-subtext">
                    * {i18n['objectPage.geoSubtext']}
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    languages: state.languages,
    objectPage: state.objectPage,
    defaultLat: state.configuration.main.defaultLat,
    isGoogleApiInit: state.configuration.isGoogleApiInit
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Location);


// WEBPACK FOOTER //
// ./src/components/PropertyPage/Location.js